<template>
  <div class="customField pb-4">
    <div
      class="v-label mb-2"
      :class="{
        'v-label--is-disabled': !addFlag || !editFlag,
        'theme--light': !this.$vuetify.theme.dark,
        'theme--dark': this.$vuetify.theme.dark,
      }"
    >
      5. If “Other”, what is the name of your coaching certification?
      <span class="error--text">*</span>
    </div>

    <v-container class="pa-0">
      <v-row
        align="center"
        justify="start"
      >
        <span
          v-for="(cert, key) in certificationsOther"
          :key="`cert${key}`"
          class="d-flex pr-0 pb-0 flex-wrap"
        >
          <v-chip
            class="certificationChip"
            close
            :disabled="!editFlag"
            @click:close="removeCertification(key)"
          >
            {{ cert }}
          </v-chip>
        </span>

        <v-col
          cols="12"
        >
          <v-text-field
            v-model="inputCertifications"
            placeholder="Input certification name"
            clearable
            counter="128"
            maxlength="128"
            :disabled="!addFlag || !editFlag"
            :rules="rules.certificationsOther"
            class="pt-0"
            @keydown.enter="addCertification"
          >
            <template #append-outer>
              <v-btn
                v-show="editFlag"
                color="primary lighten-2"
                small
                :disabled="!addFlag || !editFlag"
                @click="addCertification"
              >
                Add
              </v-btn>
            </template>
          </v-text-field>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'Question5',

  props: {
    addFlag: {
      type: Boolean,
      default: false,
    },

    editFlag: {
      type: Boolean,
      default: false,
    },

    rules: {
      type: Object,
      default: null,
    },

    certificationsOther: {
      type: Array,
      default: null,
    },
  },

  data: () => ({
    tempSave: null,
    inputCertifications: '',
  }),

  watch: {
    addFlag(newValue) {
      if (newValue && this.tempSave) {
        this.$emit('update:certificationsOther', this.tempSave);
        this.tempSave = null;
      } else if (!newValue && this.certificationsOther && this.certificationsOther.length) {
        this.tempSave = this.certificationsOther;
        this.$emit('update:certificationsOther', []);
      }
    },
  },

  methods: {
    addCertification() {
      if (this.inputCertifications !== '') {
        const addData = [...this.certificationsOther, this.inputCertifications];
        this.$emit('update:certificationsOther', addData);
        this.inputCertifications = '';
      }
    },

    removeCertification(index) {
      const removeData = this.certificationsOther.filter((el, key) => index !== key);
      this.$emit('update:certificationsOther', removeData);
    },
  },
};
</script>

<style lang="scss">
  .certificationChip {
    &.v-chip {
      word-break: break-word;
      white-space: normal;
      height: 100%;
      padding: 4px 12px;
      margin: 5px 4px !important;
    }
  }
</style>
